import { isClient } from '~utils/lodash/isServer';

/**
 * 마이페이지 1회이상 방문여부
 */
export function getVisitedMypageToStorage() {
  if (isClient) {
    const storage = window.localStorage;

    return !!storage.getItem('VISITED_MYPAGE');
  }
}

/**
 * 마이페이지 1회이상 방문 시 local storage 저장
 */
export function setVisitedMypageToStorage() {
  if (isClient) {
    const storage = window.localStorage;

    storage.setItem('VISITED_MYPAGE', 'true');
  }
}
